import { createAction } from '@reduxjs/toolkit';
import { storeName } from '../config';
import { ReviewCyclesFilters } from '../interfaces';

export const changeFilter = createAction<{
  key: keyof ReviewCyclesFilters;
  value: string | number | number[] | null;
}>(`${storeName}/changeFilter`);
